import styled from 'styled-components'
import { themeGet } from 'styled-system'

export const StyledList = styled.ul`
  li {
    margin-bottom: 0.1875rem;
    color: ${themeGet('colors.darkGray')};
  }
`
